import * as React from "react";
import styles from "./show_more_button.module.sass";

type ShowMoreButtonProps = {
  children: React.ReactNode;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  isExpanded?: boolean;
};

export const ShowMoreButton = ({
  children,
  onClick,
  isExpanded = false,
}: ShowMoreButtonProps) => (
  <button
    type="button"
    className={
      isExpanded
        ? `toggle-more less ${styles.toggleBrandsShownButton}`
        : `toggle-more ${styles.toggleBrandsShownButton}`
    }
    onClick={onClick}
  >
    {children}
  </button>
);
